import * as OM from '@/model';

class Enum {
    static GetAll(){
        let ris = [];
        for(let p in this){
            ris.push(this[p]);
        }
        return ris;
    }
    static GetDictionary(){
        let ris = {};
        for(let p in this){
            ris[p] = this[p];
        }
        return ris;
    }
}


export class AppRoles extends Enum
{
    static SuperAdmin: string = "SuperAdmin";
    static User: string = "User";
    static Guest: string = "Guest";
}

export class CommessaRoles extends Enum
{
    static Admin: string = "Amministratore";
    static Editor: string = "Editor";
    static Viewer: string = "Viewer";
}

export class ApprovalResult extends Enum
{
    static InAttesa: string = "In attesa";
    static Approvato: string = "Approvato";
    static Rifiutato: string = "Rifiutato";
}

export class ShopOrderStatus extends Enum
{
    static Bozza: string = "Bozza";
    static DaApprovare: string = "Da approvare";
    static AttesaPreventivo: string = "Attesa preventivo";
    static AttesaPagamento: string = "Attesa pagamento";
    static InProduzione: string = "In produzione";
    static Spedito: string = "Spedito";
    static Consegnato: string = "Consegnato";
    static Cancellato: string = "Cancellato";
}

export function statusColorByValue(status: string): string {
    const colors: Record<number, string> = {
        [ShopOrderStatus.Bozza]: 'secondary',
        [ShopOrderStatus.DaApprovare]: 'primary-outline',
        [ShopOrderStatus.AttesaPreventivo]: 'primary',
        [ShopOrderStatus.AttesaPagamento]: 'warning',
        [ShopOrderStatus.InProduzione]: 'info',
        [ShopOrderStatus.Spedito]: 'success',
        [ShopOrderStatus.Consegnato]: 'success',
        [ShopOrderStatus.Cancellato]: 'danger',
    };
    return colors[status] ?? 'secondary';
}

export class QrAuthType extends Enum
{
    static Password: string = "Password";
    static Login: string = "Login";
    static LoginOrPassword: string = "LoginOrPassword";
    // static LoginAndPassword: string = "LoginAndPassword";
}

export class MappingDefinitionActions extends Enum
{
    static SimpleValue: string = "SimpleValue";
    static Commessa: string = "Commessa";
    static Template: string = "Template";
    static Cliente: string = "Cliente";
}

export class PdfDocumentTypes extends Enum
{
    // static Privacy: string = "Privacy";
    // static TermsAndConditions: string = "TermsAndConditions";
    static SubscriptionContract: string = "SubscriptionContract";
}

export class QrConfigMappingFields extends Enum
{
    static Name = { label: "Nome", propertyName: "Name" };
    static Description = { label: "Descrizione", propertyName: "Description" };
    static Info = { label: "Info", propertyName: "Info" };
    // static CreatedBy = { label: "Creato da", propertyName: "CreatedBy" };
    // static ModifiedBy = { label: "Modificato da", propertyName: "ModifiedBy" };
    static RedirectToUrl = { label: "Url", propertyName: "RedirectToUrl" };
    static IsActive = { label: "Attivo", propertyName: "IsActive" };
    static IsAuthRequired = { label: "Richiesta autenticazione", propertyName: "IsAuthRequired" };
    static AuthType = { label: "Tipo autenticazione", propertyName: "AuthType" };
    static AuthPassword = { label: "Password", propertyName: "AuthPassword" };
}

export const PdfDocumentFields: Record<string, string[]> = {
    // [PdfDocumentTypes.Privacy]: ["name", "surname", "address"],
    // [PdfDocumentTypes.TermsAndConditions]: ["name", "surname"],
    [PdfDocumentTypes.SubscriptionContract]: [
        "user.Name",
        "user.Surname",
        "user.CompanyName",
        "user.VatNumber",
        "user.Address",
        "sub.Code",
        "sub.LicenseType",
        "sub.GeneratedQrLimit",
        "sub.ActiveQrLimit",
        "sub.MaxCommesse",
        "sub.StartsOn",
        "sub.EndsOn",
    ]
};